import FilterModel from "app/components/FilterModel";
import PageLoader from "app/components/PageLoader";
import PaginatedTable from "app/components/table/PaginationTable";
import { slabBifurcationHeader } from "app/constants/table-header-constants";
import useSlabUpdateReport from "./useSlabUpdateReport";

const SlabUpdateReport = () => {
  const {
    pageLoading,
    filteredData,
    paginationHandler,
    navigate,
    totalNumber,
    currentPage,
    dataPerPage,
    pageCount,
    sectionObj,
    isFilterOpen,
    setIsFilterOpen,
    values,
    setValues,
    resetfilterModel,
    handleSubmit,
    handleFilterCancel,
    fetchReportData,
    isFiltering,
  } = useSlabUpdateReport();

  return (
    <>
      <div className="cms-content__container">
        <div className="cms-content__container billmanagement">
          <PaginatedTable
            fulldata={filteredData}
            sectionObj={sectionObj}
            columns={slabBifurcationHeader}
            data={filteredData}
            currentPage={currentPage}
            dataPerPage={dataPerPage}
            pageCountNumber={pageCount}
            totalNumber={totalNumber}
            pageLoading={pageLoading}
            navigate={navigate}
            isLoading={pageLoading}
            paginationHandler={paginationHandler}
            fetchData={fetchReportData}
            isFiltering={isFiltering}
            values={values}
          />
        </div>
        {isFilterOpen && (
          <FilterModel
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            onSubmit={handleSubmit}
            onCancel={handleFilterCancel}
            values={values}
            setValues={setValues}
            resetfilter={resetfilterModel}
          >
            <>
              <div className="offcanvas-item">
                <label>Mall Name:</label>
                <input
                  type="text"
                  value={values?.mallName}
                  onChange={(e) =>
                    setValues({ ...values, mallName: e.target.value })
                  }
                />
              </div>
              <div className="offcanvas-item">
                <label>Membership Type:</label>
                <input
                  type="text"
                  value={values?.membershipType}
                  onChange={(e) =>
                    setValues({ ...values, membershipType: e.target.value })
                  }
                />
              </div>
              <label>First Bill Date ranges:</label>
              <div className="offcanvas-item">
                <label>Start Date</label>
                <input
                  type="date"
                  value={values?.firstBillUploadDateStart}
                  max={values?.firstBillUploadDateEnd}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      firstBillUploadDateStart: e.target.value,
                    })
                  }
                />
              </div>
              <div className="offcanvas-item">
                <label>End Date</label>
                <input
                  type="date"
                  value={values?.firstBillUploadDateEnd}
                  min={values?.firstBillUploadDateStart}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      firstBillUploadDateEnd: e.target.value,
                    })
                  }
                />
              </div>
            </>
          </FilterModel>
        )}
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default SlabUpdateReport;
